let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gu7Yq")).then(() => parcelRequire('85UpT'));